export const partCreatorConstants = {
  PART_CREATOR_REQUEST: "PART_CREATOR_REQUEST",
  PART_CREATOR_SUCCESS: "PART_CREATOR_SUCCESS",
  PART_CREATOR_FAILURE: "PART_CREATOR_FAILURE",

  PART_CREATOR_SEARCH_REQUEST: "PART_CREATOR_SEARCH_REQUEST",
  PART_CREATOR_SEARCH_SUCCESS: "PART_CREATOR_SEARCH_SUCCESS",
  PART_CREATOR_SEARCH_FAILURE: "PART_CREATOR_SEARCH_FAILURE",
};
